import { Injectable } from '@angular/core';
import { QuickLinksData } from '../_models/common/listingParams';
@Injectable({
  providedIn: 'root'
})
export class DataStorageService {

  private data: any;

  setData(data: QuickLinksData) {
    this.data = data;
  }

  getData() {
    return this.data || null;
  }

  hasData() {
    return this.data != null && this.data != undefined;
  }

}
